// Design System
import DeliveryIcon24 from 'jl-design-system/elements/icons-jb/Delivery24PxFilled';
import DeliveryIcon24Outlined from 'jl-design-system/elements/icons-jb/Delivery24PxOutlined';
import InStoreIcon24Outlined from 'jl-design-system/elements/icons-jb/InStore24PxOutlined';
import InStoreIcon24 from 'jl-design-system/elements/icons-jb/InStore24PxFilled';
import DeliveryIcon32 from 'jl-design-system/elements/icons-jb/Delivery32PxFilled';
import DeliveryIcon32Outlined from 'jl-design-system/elements/icons-jb/Delivery32PxOutlined';
import InStoreIcon32Outlined from 'jl-design-system/elements/icons-jb/InStore32PxOutlined';
import InStoreIcon32 from 'jl-design-system/elements/icons-jb/InStore32PxFilled';

// Config
import deliveryConstants from '@constants/deliveryConstants';
import { CLICK_AND_COLLECT_MIN_VALUE } from '@constants/clickCollectConstants';

export const getIcon = (deliveryId = '', isSelected = false, small = false) => {
  let DeliveryIcon = DeliveryIcon32;
  let DeliveryIconOutlined = DeliveryIcon32Outlined;
  let InStoreIcon = InStoreIcon32;
  let InStoreIconOutlined = InStoreIcon32Outlined;

  if (small) {
    DeliveryIcon = DeliveryIcon24;
    DeliveryIconOutlined = DeliveryIcon24Outlined;
    InStoreIcon = InStoreIcon24;
    InStoreIconOutlined = InStoreIcon24Outlined;
  }

  const deliveryIcon = isSelected ? DeliveryIcon : DeliveryIconOutlined;
  const collectionIcon = isSelected ? InStoreIcon : InStoreIconOutlined;
  const Icon = deliveryId === deliveryConstants.DELIVERY ? deliveryIcon : collectionIcon;

  return Icon;
};

export const getTabTitleWithCostInfo = (basketTotalValue = '', deliveryId = '', minimal = false) => {
  let cost;

  const basketCostRange = {
    min: CLICK_AND_COLLECT_MIN_VALUE,
    max: 50,
  };

  const COLLECTION_COST_INFO = 'from £2.95';
  const DELIVERY_COST_INFO = 'from £4.50';
  const FREE_COLLECTION = minimal ? 'Free' : 'Free\ncollection';
  const FREE_STANDARD_DELIVERY = minimal ? 'Free' : 'Free standard\nUK delivery';

  const isClickAndCollectTab = deliveryId === deliveryConstants.CLICK_AND_COLLECT;

  const basketTotalValueNumber = Number(basketTotalValue);

  if (basketTotalValueNumber < basketCostRange.min) {
    cost = isClickAndCollectTab ? COLLECTION_COST_INFO : DELIVERY_COST_INFO;
  } else if ((basketTotalValueNumber >= basketCostRange.min) && (basketTotalValueNumber < basketCostRange.max)) {
    cost = isClickAndCollectTab ? FREE_COLLECTION : DELIVERY_COST_INFO;
  } else if (basketTotalValueNumber >= basketCostRange.max) {
    cost = isClickAndCollectTab ? FREE_COLLECTION : FREE_STANDARD_DELIVERY;
  }

  return cost;
};
